import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import {
  Col,
  Row,
  Card,
  Button,
  CardBody,
  Container,
  Spinner,
} from "reactstrap";

import AlertMessage from "components/Alert";
import { alertActions } from "redux/_actions";
import WebAPI from "services/WebAPI";
import InvoiceForm from "./form";
import { getPartner } from "screens/partner/service";

const PartnerEdit = () => {
  let history = useHistory();
  const { id, type } = useParams();
  const [customer, setCustomer] = useState(null);
  const [partner, setPartner] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (type === "customer") fetchCustomerDetails();
    if (type === "partner") fetchPartner();
  }, [id]);

  const dispatch = useDispatch();

  const fetchCustomerDetails = () => {
    setLoading(true)
    WebAPI.get(`/Customers/Details/${id}`).then(({ data: res }) => {
      if (res.status) {
        setCustomer(res.data);
      } else {
        dispatch(
          alertActions.error(
            res.message === "Not allowed" ? "Customer not found" : res.message
          )
        );
        setCustomer({});
        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 2500);
      }
    });
    setLoading(false)
  };

  const fetchPartner = () => {
    setLoading(true);
    getPartner(id)
      .then((result) => {
        if (result) {
          setPartner(result);
        } else {
          dispatch(alertActions.error("Partner not found"));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(alertActions.error("Something went wrong"));
      });
    setTimeout(() => {
      dispatch(alertActions.clear());
    }, 2500);
    setLoading(false);
  };

  if (loading) {
    return (
      <Spinner
        /* type={type} color={color} */ style={{
          position: "absolute",
          left: "50%",
          transform: "transform: translate(-50%, -50%)",
        }}
      />
    );
  }

  return (
    <>
      <Container className="container-modal" fluid>
        <div className="common-headers">
          <Button
            className="common-btn-back mr-2"
            outline
            onClick={() => history.go(-1)}
          >
            <i className="fas fa-chevron-left" />
          </Button>
          Generate Invoice For {type==="partner" ? partner?.EntityName : customer?.FirstName}
        </div>
        <Row>
          <Col xs="6">
            <Card className="shadow">
              <CardBody>
                <InvoiceForm />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PartnerEdit;
